import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import AssetTypeForm from './AssetTypeForm';

const AssetTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const AssetTypeEdit = (props: any) => {
  return (
    <Edit actions={<AssetTypeActions {...props} />} {...props}>
      <AssetTypeForm />
    </Edit>
  );
};

export default AssetTypeEdit;
